import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DashboardTabsNavigation from './DashboardTabsNavigation';
import DashboardTabsContent from './DashboardTabsContent';
import DashboardDocumentStage from './DashboardDocumentStage';
import { addTranslations } from '../../Utils/Locale';
import translations from './translations.yml';
import { getDefaultPurchaseType, shownType } from '../Purchase/PurchaseType';
addTranslations(translations);
const DashboardDocument = ({ index, user, recommendation, panelContent, assets, products, productDocument, allPartners, freeRegistration, isNemAdgangRequired, canEdit, canDelete, canDownload, tab = 1 }) => {
    const [selectedTab, setSelectedTab] = useState(tab);
    const [toggled, setToggled] = useState(false);
    const [selectedType, setSelectedType] = useState(recommendation.document && recommendation.document.isPurchased ? shownType[recommendation.document.purchasedAsType] : getDefaultPurchaseType());
    function selectTab(tab) {
        setSelectedTab(tab);
        setToggled(true);
    }
    return (_jsxs("div", Object.assign({ id: `section-${index}`, className: 'overflow-hidden relative flex flex-col md:w-full md:h-auto bg-gray-f6 md:bg-white p-2 pb-10 md:rounded-xl md:px-5 md:py-6 md:grid md:grid-cols-4 md:grid-flow-col md:gap-4 md:grid-rows-dashLayout md:shadow-md md:mb-6' }, { children: [_jsx(DashboardDocumentStage, { index: index, panelContent: panelContent, product: productDocument, products: products, allPartners: allPartners, user: user, freeRegistration: freeRegistration, isNemAdgangRequired: isNemAdgangRequired, recommendation: recommendation, canDelete: canDelete, canEdit: canEdit, canDownload: canDownload, selectedType: selectedType }), _jsx("h1", Object.assign({ className: 'card-head tailwind-reset mb-4 text-4xl font-medium text-dark-teal break-words leading-none py-2 md:row-span-1 md:col-span-2 order-1 md:order-2 md:h-auto md:px-2 md:mb-0 md:py-0 md:pt-4' }, { children: recommendation.product.title })), _jsx(DashboardTabsNavigation, { selectedTab: selectedTab, selectTab: selectTab }), _jsx(DashboardTabsContent, { selectedTab: selectedTab, selectTab: selectTab, recommendation: recommendation, assets: assets, toggled: toggled, hideContent: () => setToggled(false), selectedType: selectedType, setSelectedType: setSelectedType })] })));
};
DashboardDocument.propTypes = {
    index: PropTypes.string,
    user: PropTypes.shape({ onboardingPartner: PropTypes.shape({ isPriceReviewActive: PropTypes.bool }) }).isRequired,
    recommendation: PropTypes.shape({
        text: PropTypes.string.isRequired,
        startTab: PropTypes.number,
        product: PropTypes.shape({
            machineName: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired
        }).isRequired,
        document: PropTypes.shape({
            id: PropTypes.number.isRequired,
            isPurchased: PropTypes.bool.isRequired,
            purchasedAsType: PropTypes.string
        }),
        process: PropTypes.array.isRequired
    }).isRequired,
    panelContent: PropTypes.shape({ button: PropTypes.array }).isRequired,
    assets: PropTypes.array.isRequired,
    products: PropTypes.array.isRequired,
    productDocument: PropTypes.shape({
        path: PropTypes.string.isRequired,
        isNemAdgangRequired: PropTypes.bool.isRequired,
        document: PropTypes.object,
        documentAction: PropTypes.string,
        documentPath: PropTypes.string,
        documentStatusText: PropTypes.string
    }).isRequired,
    allPartners: PropTypes.array,
    freeRegistration: PropTypes.bool,
    isNemAdgangRequired: PropTypes.bool.isRequired,
    canEdit: PropTypes.bool,
    canDelete: PropTypes.bool,
    canDownload: PropTypes.bool,
    tab: PropTypes.number
};
export default DashboardDocument;
